/* eslint-disable react/no-array-index-key */

import { Accordion } from '../accordion';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SpecsTable: Component = ({
  compareList,
}) => (
  <>
    <Accordion
      title="ENGINE & TRANSMISSION"
      defaultOpen>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Engine Capacity (cc)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-engine-capacity`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.engineCapacity
                  ? item.subModels[0]?.specifications.engineCapacity
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-engine-capacity`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Engine Type
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-engine-type`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.engineType ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-engine-type`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Battery Type
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-battery-type`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.batteryType ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-battery-type`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Fuel Type
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-fuel-type`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.fuelType ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-fuel-type`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Drive Type
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-drive-type`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.driveType ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-drive-type`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Transmission
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-transmission`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.transmission ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-arf`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="PERFORMANCE">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Power (bhp)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-power`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.power
                  ? item.subModels[0]?.specifications.power.toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-power`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Engine Power(bhp)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.powerEngine}-engine-power`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.powerEngine
                  ? item.subModels[0]?.powerEngine.toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-engine-power`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Motor Power (bhp)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.powerMotor}-motor-power`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.powerMotor
                  ? item.subModels[0]?.powerMotor
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-motor-power`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Torque (Nm)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-torque`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.torque
                  ? item.subModels[0]?.specifications.torque.toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-torque`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Acceleration (0-100 km/h)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-acceleration`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.acceleration
                  ? item.subModels[0]?.specifications.acceleration
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-acceleration`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Top Speed (km/h)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-top-speed`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.topSpeed
                  ? item.subModels[0]?.specifications.topSpeed.toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-top-speed`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Fuel Consumption (km/L)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-fuel-consumption`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.fuelConsumption ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-fuel-consumption`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        CO2 Emission (g/km)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-co2-emission`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.co2EmissionLta
                  ? item.subModels[0]?.specifications.co2EmissionLta
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-co2-emission`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="MEASUREMENTS">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Seating Capacity
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-seating-capacity`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.seatingCapacity ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-seating-capacity`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Dimensions (mm)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-dimensions`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.dimensions ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-dimensions`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Wheelbase (mm)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-wheelbase`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.wheelbase
                  ? item.subModels[0]?.specifications.wheelbase.toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-wheelbase`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Min. Turning Radius (mm)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-min-turning-radius`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.minTurningRadius
                  ? item.subModels[0]?.specifications.minTurningRadius
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-min-turning-radius`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Kerb Weight (kg)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-kerb-weight`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.kerbWeight
                  ? item.subModels[0]?.specifications.kerbWeight
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-kerb-weight`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Fuel Tank Capacity (L)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-fuel-tank-capacity`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.fuelTankCapacity
                  ? item.subModels[0]?.specifications.fuelTankCapacity
                    .toLocaleString()
                  : 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-fuel-tank-capacity`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Boot/Cargo Capacity (L)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-cargo-capacity`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.cargoCapacity ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-cargo-capacity`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="SUSPENSION, BRAKES & WHEELS">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Suspension (Front)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-suspension-front`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.suspensionFront ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-suspension-front`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Suspension (Rear)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-suspension-rear`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.suspensionRear ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-suspension-rear`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Brakes (Front)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-brakes-front`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.breakFront ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-brakes-front`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Brakes (Rear)
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-brakes-rear`}
                className={`${styles.containerScrollCell}`}>
                {item.subModels[0]?.specifications.breakRear ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-brakes-rear`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Rim Size
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-rim-size`}
                className={`${styles.containerScrollCell}`}>
                {`${item.subModels[0]?.specifications.rimSize}"` ?? 'N/A'}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-rim-size`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
  </>
);
